import { HomeFeaturedArticleType } from '@nextTypes/guides';
import { RecipesAndGuidesContainer } from '@components/RecipesAndGuides/RecipesAndGuidesContainer';
import { createImageCards } from './RecipesAndGuidesUtils';

type Props = {
  articles: HomeFeaturedArticleType[];
};

export const SleepSection = ({ articles }: Props): JSX.Element => {
  const cards = createImageCards(articles, 3);
  return (
    <RecipesAndGuidesContainer
      backgroundColour="bg-blue"
      buttonColour="White"
      categoryTitle="Sleep"
      categoryTitleColour="text-mono-white"
      cta="More zzzZZZ"
      ctaColour="text-mono-white"
      href="/guides/category/sleeping"
      descriptionColour="text-mono-white"
    >
      <div className="flex flex-col items-center justify-center text-blue lg:flex-row xl:justify-between">
        {cards}
      </div>
    </RecipesAndGuidesContainer>
  );
};
